import { Checkbox, Modal } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import { useEffect } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

// import useGetDomains from '../hooks/useGetdomains';
// import useGetDomains from 'pages/profile/hooks/useGetdomains';
import useUpdatePublishBlog from '../hooks/useUpdatepuplishBlogs';

const PublishModal = ({
  setPublishModal,
  publishModal,
  publishData,
  setPublishData,
  BlogId,
  setBlogId,
}) => {
  const { handleSubmit } = useForm();

  const closeModal = () => {
    setBlogId(null);
    setPublishData(null);
    setPublishModal(false);
  };

  const publishaBlog = useUpdatePublishBlog(closeModal);
  const [toPublish, setToPublish] = useState([]);

  useEffect(() => {
    setToPublish(publishData);
  }, [publishData]);

  const checkAndunCkeckBlogid = (id) => {
    toPublish?.forEach((element) => {
      if (element?.domain === id) {
        if (element?.is_published === true) {
          setToPublish((toPublish) =>
            toPublish.map((element) => {
              if (element?.domain === id) {
                return { ...element, is_published: false };
              }

              return element;
            })
          );
        } else {
          setToPublish((toPublish) =>
            toPublish.map((element) => {
              if (element?.domain === id) {
                return { ...element, is_published: true };
              }

              return element;
            })
          );
        }
      }
    });
  };

  const publishformData = () => {
    const data1 = toPublish?.map((each) => {
      return {
        id: each?.domain,
        is_published: each?.is_published,
      };
    });
    publishaBlog.mutate({ blog_id: BlogId, published_on: [...data1] });
  };

  return (
    <div className=''>
      <Modal
        opened={publishModal}
        onClose={() => {
          setPublishModal(false);
          setPublishData(null);
        }}
        title='Choose domain(s) to publish'
        size={'50%'}
        centered
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        transitionDuration={100}
        overflow='inside'
        className='px-10'
        classNames={{
          title: 'text-lg font-semibold  mx-auto',
          body: 'scroller h-full',
        }}
      >
        <form onSubmit={handleSubmit(publishformData)}>
          {!toPublish?.length ? (
            <div className='flex justify-center my-8'>
              <p className='text-gray3'>Please add domains in profile</p>
            </div>
          ) : (
            <div className='space-y-5 px-14 my-8  '>
              {toPublish?.map((eachDomain) => {
                return (
                  <div key={eachDomain?.domain}>
                    <Checkbox
                      checked={eachDomain?.is_published}
                      onChange={() => checkAndunCkeckBlogid(eachDomain?.domain)}
                      label={
                        <p className='text-medium font-semibold text-[#8E8E8E]'>
                          {eachDomain?.domain__name}
                        </p>
                      }
                    />
                  </div>
                );
              })}
            </div>
          )}
          <div className='flex justify-center items-center gap-3 py-8'>
            <button
              type='button'
              onClick={() => {
                setPublishModal(false);
                setPublishData(null);
              }}
            >
              <SecondaryButton>cancel</SecondaryButton>
            </button>

            <button
              disabled={
                !toPublish?.filter((element) => element?.is_published)?.length
              }
              className={`${
                !toPublish?.filter((element) => element?.is_published)?.length
                  ? 'opacity-60 cursor-not-allowed'
                  : ''
              }`}
            >
              <PrimaryButton>Publish</PrimaryButton>
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default PublishModal;
